<template>
  <div class="main-sidebar-wrapper">
    <div class="sidebar-wrapper">
      <div class="sidebar-header-responsive">
        <router-link :to="{ name: 'Profile' }" class="header-link profile-link header-link-transparent float-left" @click.native="toggleSidebarAndLog('PROFILE')" >
          <div class="position-relative">
            <img class="header-link-img" v-if="user.photo === 'https://s3.us-east-2.amazonaws.com/dev-player-photo/default-photo.png' || user.parentId" src="@/assets/images/icons/profile.png" alt="avatar"/>
              <img class="header-link-img profile-image" v-if="user.photo !== 'https://s3.us-east-2.amazonaws.com/dev-player-photo/default-photo.png' && user.photo" :src="user.photo" alt="avatar"/>
            <span class="user-info text-uppercase">
              {{user.firstName}} {{user.lastName}}
            </span>
          </div>
        </router-link>
        <a class="header-link logout-link float-right" @click.prevent="logout()">
          <img class="header-link-img" src="@/assets/images/icons/logout.png" alt="header link" /> {{ $t('SIDEBAR.logout')}}
        </a>
      </div>
      <ul id="sidebar-nav" class="sidebar-nav">
        <li class="sidebar-nav-item child-picker" v-if="user.parentId != null && user.playerDetails.length">
          <a @click='toggleChoosePlayer = !toggleChoosePlayer' v-if="account != null" v-on:mouseover="showChildPicker()" v-on:mouseout="hideChildPicker($event)">
            <span class="sidebar-nav-item-icon-wrapper">
              <img class="sidebar-nav-item-icon" :src="account.photo" alt="account photo" />
            </span>
            <div class="link-text link-text-nav">
              {{ account.firstName }} {{ account.lastName }}
            </div>
            <span class="collapse-arrow collapse-arrow-down" v-show='!toggleChoosePlayer'></span>
            <span class="collapse-arrow collapse-arrow-up" v-show='toggleChoosePlayer'></span>
          </a>

          <div id="subnavManage" v-show='toggleChoosePlayer' v-if="sidebarExpanded">
              <ul class="sidebar-subnav padding-top-10">
                  <li v-for="player in subAccounts" :key="player.playerId" class="sidebar-subnav-item">
                    <a v-on:click="choosePlayer(player)" @click='toggleChoosePlayer = !toggleChoosePlayer' :class="[player.playerId == account.playerId ? 'selected' : '']">
                      <div>
                        <img :src="player.photo" alt="player photo" />
                      </div>
                      <span> {{ player.firstName }} {{ player.lastName }}</span>
                    </a>
                  </li>
              </ul>
          </div>
        </li>
        <li class="sidebar-nav-item">
          <router-link :to="{ name: 'Dashboard' }" @click.native="toggleSidebarAndLog('DASHBOARD')">
            <span class="sidebar-nav-item-icon-wrapper">
              <img class="sidebar-nav-item-icon" src="@/assets/images/icons/dashboard.png" alt="dashboard" />
            </span>
            <span class="link-text">
              {{ $t('SIDEBAR.dashboard')}}
            </span>
          </router-link>
        </li>
        <li class="sidebar-nav-item">
          <router-link :to="{ name: 'Calendar' }" @click.native="toggleSidebarAndLog('CALENDAR')">
            <span class="sidebar-nav-item-icon-wrapper">
                <img class="sidebar-nav-item-icon" src="@/assets/images/icons/calendar.png" alt="calendar" />
            </span>
            <span class="link-text">
              {{ $t('SIDEBAR.calendar')}}
            </span>
          </router-link>
        </li>
        <li class="sidebar-nav-item">
          <router-link :to="{ name: 'SessionHistory' }" @click.native="toggleSidebarAndLog('SESSION_HISTORY')">
            <span class="sidebar-nav-item-icon-wrapper">
                <img class="sidebar-nav-item-icon" src="@/assets/images/icons/session-history.png" alt="session history" />
            </span>
            <span class="link-text">
              {{ $t('SIDEBAR.sessionHistory')}}
            </span>
          </router-link>
        </li>
        <li class="sidebar-nav-item">
          <router-link :to="{ name: 'Leaderboard' }" @click.native="toggleSidebarAndLog('LEADERBOARD')">
            <span class="sidebar-nav-item-icon-wrapper">
              <img class="sidebar-nav-item-icon" src="@/assets/images/icons/leaderboard.png" alt="leaderboard" />
            </span>
            <span class="link-text">
              {{ $t('SIDEBAR.leaderboard')}}
            </span>
          </router-link>
        </li>
         <li class="sidebar-nav-item playbook-picker" >
          <a :class="{'active':$route.path.includes('playbook')}" v-b-toggle="sidebarExpanded?'subnavPlaybook':undefined" class="playbook-anchor" @click='onTogglePlaybook()' v-on:mouseover="showPlaybook()" v-on:mouseout="hidePlaybook($event)">
            <span class="sidebar-nav-item-icon-wrapper">
              <img class="sidebar-nav-item-icon" src="@/assets/images/sidebar/playbook.png" alt="playbook icon" />
            </span>
            <div class="link-text link-text-nav text-uppercase">
               {{ $t('SIDEBAR.playbook')}}
            </div>
            <span class="collapse-arrow collapse-arrow-down" v-show='!togglePlaybook'></span>
            <span class="collapse-arrow collapse-arrow-up" v-show='togglePlaybook'></span>
          </a>

          <b-collapse id="subnavPlaybook" >
            <div>
              <ul class="sidebar-subnav padding-top-10">
                  <li class="sidebar-subnav-item">
                     <router-link :to="{ name: 'GettingStarted' }" @click.native="toggleSidebarAndLog('GETTING_STARTED')">
                       <span class="link-text">
              {{ $t('BREADCRUMB.gettingStarted')}}
            </span>
                     </router-link>
                  </li>
                  <li class="sidebar-subnav-item">
                     <router-link :to="{ name: 'ReadingTheData' }" @click.native="toggleSidebarAndLog('READING_DATA')">
                       <span class="link-text">
              {{ $t('BREADCRUMB.readingData')}}
            </span>
                     </router-link>
                  </li>
                  <li class="sidebar-subnav-item">
                     <router-link :to="{ name: 'DoingMoreWithData' }" @click.native="toggleSidebarAndLog('DOING_MORE')">
                       <span class="link-text">
              {{ $t('BREADCRUMB.doingMore')}}
            </span>
                     </router-link>
                  </li>
                  <li class="sidebar-subnav-item">
                     <router-link :to="{ name: 'Troubleshooting' }" @click.native="toggleSidebarAndLog('TROUBLESHOOTING')">
                       <span class="link-text">
              {{ $t('BREADCRUMB.troubleshooting')}}
            </span>
                     </router-link>
                  </li>
              </ul>
            </div>
          </b-collapse>
        </li>
        <li class="sidebar-nav-item">
          <a :href="'https://learn.beyondpulse.com/' + $i18n.locale + '/'" target="blank">
            <span class="sidebar-nav-item-icon-wrapper">
              <img class="sidebar-nav-item-icon" src="@/assets/images/icons/education.png" alt="education" />
            </span>
            <span class="link-text">
              {{ $t('SIDEBAR.education')}}
            </span>
            <i class="fas fa-external-link-alt" aria-hidden="true"></i>
          </a>
        </li>
        <li class="sidebar-nav-item">
          <router-link :to="{ name: 'Shop' }" @click.native="toggleSidebarAndLog('SHOP')">
            <span class="sidebar-nav-item-icon-wrapper">
              <img class="sidebar-nav-item-icon" src="@/assets/images/icons/view-icon.png" alt="view" />
            </span>
            <span class="link-text">
              {{ $t('SIDEBAR.shop')}}
            </span>
          </router-link>
        </li>
      </ul>
      <div class="sidebar-footer-note">
        <div class="store-wrapper">
          <p>{{ $t('SIDEBAR.downloadText')}}</p> 
          <div class="icon-wrapper left-icon-wrapper">
              <a href="https://apps.apple.com/us/app/beyond-pulse-for-players/id1445128542" target="_blank" rel="noopener">
                  <img src="@/assets/images/sidebar/app-store-icon.png" alt="app store icon">
              </a>
          </div>
          <div class="icon-wrapper right-icon-wrapper">
              <a href="https://play.google.com/store/apps/details?id=com.player.beyond.pulse" target="_blank" rel="noopener">
                  <img src="@/assets/images/sidebar/google-play-icon.png" alt="google play icon">
              </a>
          </div>
        </div>
        <div class="copyright-wrapper">
          &copy; {{new Date().getFullYear()}} <span class="orange-text-clr">Beyond Pulse</span> {{ $t('SIDEBAR.privacy.llc')}}
        </div>
        <div class="legal-links-wrapper">
          <a class="link link-gray hover-white" target="blank" :href="TERMS_URL.replace(':locale', this.$i18n.locale)" rel="noopener">{{ $t('SIDEBAR.privacy.terms')}}</a>
          <span class="text-gray separator-dot">&middot;</span>
          <a class="link link-gray hover-white" target="blank" :href="PRIVACY_POLICY_URL.replace(':locale', this.$i18n.locale)" rel="noopener">{{ $t('SIDEBAR.privacy.generalPrivacy')}}</a>
          <span class="text-gray separator-dot">&middot;</span>
          <a class="link link-gray hover-white" href="#" @click.prevent="openSupportChat">{{ $t('SIDEBAR.privacy.support')}}</a>
        </div>
      </div>
    </div>
    <div class="sidebar-nav-item child-picker">
      <div class="dropdown-side-menu" v-if="!sidebarExpanded" :class="{'closed' : !showChildList}" v-on:mouseover="showChildPicker()" v-on:mouseout="hideChildPicker()" >
        <ul class="sidebar-subnav">
            <li class="sidebar-subnav-item" v-for="player in subAccounts" :key="player.playerId">
                <a v-on:click="choosePlayer(player)" @click='toggleChoosePlayer = !toggleChoosePlayer' :class="[player.playerId == account.playerId ? 'selected' : '']">
                  <div class="pl-0">
                    <img :src="player.photo" alt="player photo" />
                  </div>
                  <span class="p-0"> {{ player.firstName }} {{ player.lastName }} </span>
                </a>
            </li>
        </ul>
      </div>
    </div>
    <div class="sidebar-nav-item playbook-picker">
      <div class="dropdown-side-menu playbook-menu" v-if="!sidebarExpanded" :class="{'closed' : !showPlaybookList}" v-on:mouseover="showPlaybook()" v-on:mouseout="hidePlaybook()" >
        <ul class="sidebar-subnav">
          <li class="sidebar-subnav-item">

          <span class="subnav-header text-uppercase" :class="{'active':$route.path.includes('playbook')}">{{ $t('BREADCRUMB.playbook')}}</span>
          </li>
            <li class="sidebar-subnav-item">
                     <router-link :to="{ name: 'GettingStarted' }" @click.native="toggleSidebarAndLog('GETTING_STARTED')">
                       <span class="link-text">
              {{ $t('BREADCRUMB.gettingStarted')}}
            </span>
                     </router-link>
                  </li>
            <li class="sidebar-subnav-item">
                     <router-link :to="{ name: 'ReadingTheData' }" @click.native="toggleSidebarAndLog('READING_DATA')">
                       <span class="link-text">
              {{ $t('BREADCRUMB.readingData')}}
            </span>
                     </router-link>
                  </li>
            <li class="sidebar-subnav-item">
                     <router-link :to="{ name: 'DoingMoreWithData' }" @click.native="toggleSidebarAndLog('DOING_MORE')">
                       <span class="link-text">
              {{ $t('BREADCRUMB.doingMore')}}
            </span>
                     </router-link>
                  </li>
            <li class="sidebar-subnav-item">
                     <router-link :to="{ name: 'Troubleshooting' }" @click.native="toggleSidebarAndLog('TROUBLESHOOTING')">
                       <span class="link-text">
              {{ $t('BREADCRUMB.troubleshooting')}}
            </span>
                     </router-link>
                  </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { LOGOUT } from '@/store/action.types'
import { SET_CHOSEN_ACCOUNT, SET_SUBACCOUNTS } from '@/store/mutation.types'
import { TERMS_URL, PRIVACY_POLICY_URL } from '@/constants/RouterConstants'
import { openSupportChat } from '@/common/supportChat'
import { mapActions, mapMutations, mapGetters } from 'vuex'

export default {
  name: 'Sidebar',
  props: {
    user : Object,
    onRouteChanged : Function,
    sidebarExpanded : Boolean,
    logout : Function
  },
  data () {
    return {
      TERMS_URL,
      PRIVACY_POLICY_URL,
      toggleChoosePlayer: false,
      togglePlaybook:false,
      showPlaybookList:false,
      showChildList: false
    }
  },
  computed: {
    ...mapGetters([
      'account',
      'subAccounts'
    ])
  },
  mounted () {
    if (this.user.parentId != null && this.user.playerDetails.length) {
      this.updateSubAccounts(this.user.playerDetails)
    }
    this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
      if(collapseId==='subnavPlaybook' && !isJustShown && this.togglePlaybook){
        this.togglePlaybook = false;
      }
    })
  },
  methods: {
    openSupportChat,
    ...mapActions({
      logoutAction: LOGOUT
    }),
    ...mapMutations({
      updateSelectedAccount: SET_CHOSEN_ACCOUNT,
      updateSubAccounts: SET_SUBACCOUNTS
    }),
    choosePlayer: function (player) {
      this.updateSelectedAccount(player)
      this.toggleSidebarAndLog()
    },
    toggleSidebarAndLog (name) {
      switch (name) {
        case "DASHBOARD":
          this.$amplitude.logEvent('pwa: click on sidebar dashboard link');
          break;
        case "CALENDAR":
          this.$amplitude.logEvent('pwa: click on sidebar calendar link');
          break;
        case "SESSION_HISTORY":
          this.$amplitude.logEvent('pwa: click on sidebar session history link');
          break;
        case "LEADERBOARD":
          this.$amplitude.logEvent('pwa: click on sidebar leaderboard link');
          break;
        case "GETTING_STARTED":
          this.$amplitude.logEvent('pwa: click on sidebar playbook getting started link');
          break;
        case "READING_DATA":
          this.$amplitude.logEvent('pwa: click on sidebar playbook reading data link');
          break;
        case "DOING_MORE":
          this.$amplitude.logEvent('pwa: click on sidebar playbook doing more link');
          break;
        case "TROUBLESHOOTING":
          this.$amplitude.logEvent('pwa: click on sidebar playbook troubleshooting link');
          break;
        case "SHOP":
          this.$amplitude.logEvent('pwa: click on sidebar shop link');
          break;      
        default:
          break;
      }
      // this.$amplitude.logEvent('pwa: click on sidebar link', {link: name})
      this.onRouteChanged()
    },
    showChildPicker() {
      this.showChildList = true 
    },
    onTogglePlaybook(){
      if(this.sidebarExpanded){
        this.togglePlaybook = !this.togglePlaybook;
      }
    },
    showPlaybook(){
      this.showPlaybookList = true;
    },
    hidePlaybook(){
      this.showPlaybookList=false;
    },
    hideChildPicker() {
      this.showChildList = false
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar-wrapper {
  overflow: hidden;
}

@media (max-height: 670px) and (min-width: 768px) {
  .sidebar-nav {
    height: 350px;
    overflow-y: scroll;
    overflow-x: hidden;
  }
}

@media (max-height: 576px) {
  .sidebar-footer-note {
    display: none;
  }
}
</style>

